import '@mantine/core/styles.css';

import '../App.css';

import React, { ReactNode, useEffect } from 'react';
import Footer from '../components/Footer';
import NavBar from '../components/Navbar';
import { createToast } from '../components/Toast';
import { MessageKind } from '../utils/common';
import { sendErrorToH2E } from '../utils/app';
import { AnalyticsConsentBanner } from '../components/AnalyticsConsentBanner';
import { Box, MantineProvider, Stack } from '@mantine/core';
import { Head } from 'vite-react-ssg';
import { useLocation } from 'react-router-dom';
import { CalensyncTranslation, useSyncLng } from '../contexts/CalensyncTranslationContext';
import { marketingLayoutTheme } from '../theme';
import { pathLocale } from '../utils/seo';

interface LayoutProps {
    children: ReactNode;
    onlyRequired?: boolean;
    dashboard?: boolean;
    verify_session?: boolean;
    include_navbar?: boolean;
}

const LayoutContent: React.FC<LayoutProps> = ({
    children,
    onlyRequired = false,
    dashboard = false,
    verify_session = false,
    include_navbar = true,
}) => {
    useSyncLng();
    const { pathname } = useLocation();
    const lang = pathLocale(pathname) ?? 'en';

    useEffect(() => {
        setTimeout(() => {
            const urlParams = new URLSearchParams(window.location.search);
            let err = urlParams.get('error_msg');
            if (err !== null) {
                createToast(atob(err), MessageKind.Error);
            }
            let info = urlParams.get('msg');
            if (info !== null) {
                createToast(atob(info), MessageKind.Info);
            }
        }, 0);
    }, []);

    useEffect(() => {
        const handleError = (ev: ErrorEvent) => sendErrorToH2E(ev);
        window.addEventListener('error', handleError);
        return () => {
            window.removeEventListener('error', handleError);
        };
    }, []);

    useEffect(() => {
        const root = document.querySelector('#root');
        if (root) {
            (root as HTMLElement).style.display = 'block';
        }
    }, []);

    return (
        <Box bg="gray.0" h="100vh">
            <Head htmlAttributes={{ lang }}>{null}</Head>
            <Stack justify="space-between" h="100vh">
                <div>
                    {include_navbar && <NavBar verify_session={onlyRequired} />}
                    <main className="">{children}</main>
                </div>
                <Footer onlyRequired={onlyRequired} />
            </Stack>
            <AnalyticsConsentBanner />
        </Box>
    );
};

const Layout: React.FC<LayoutProps> = (props) => {
    return (
        <MantineProvider theme={marketingLayoutTheme}>
            <CalensyncTranslation include_app={false}>
                <LayoutContent {...props} />
            </CalensyncTranslation>
        </MantineProvider>
    );
};

export default Layout;
